/* Adenzo mobile app layer — bottom tab bar behaviour (phase 3).
   Markup: snippets/adenzo-tab-bar.liquid. Styles: assets/adenzo-app.css.
   - Publishes the bar's size as --app-tabbar-height (layout) and --app-tabbar-inset (what fixed UI
     such as the sticky add-to-cart bar should sit above; 0 while the bar is hidden for the keyboard).
   - Always visible; only steps aside while a field is focused (the keyboard is up).
   - Instant feedback when a tab is tapped (see below); the tabs themselves are plain links to real pages.
   - Keeps the cart badge in sync with the header cart bubble. */
(function () {
  'use strict';

  var bar = document.getElementById('AdenzoTabBar');
  if (!bar) return;

  var root = document.documentElement;
  var badge = bar.querySelector('[data-tab-cart-count]');
  var hidden = false;
  var focusHidden = false;

  function isApp() {
    return !!(window.AdenzoApp && window.AdenzoApp.isApp());
  }

  /* ---- size / visibility ------------------------------------------------ */

  function publish() {
    var active = isApp();
    var height = active ? Math.round(bar.getBoundingClientRect().height) : 0;
    root.classList.toggle('adenzo-has-tabbar', active);
    root.style.setProperty('--app-tabbar-height', height + 'px');
    root.style.setProperty('--app-tabbar-inset', (active && !hidden ? height : 0) + 'px');
  }

  function setHidden(next) {
    if (hidden === next) return;
    hidden = next;
    bar.classList.toggle('is-hidden', hidden);
    // Off-screen controls must not stay focusable or readable by assistive tech.
    if ('inert' in bar) bar.inert = hidden;
    publish();
  }

  // A focused field means the keyboard is coming up: get out of its way.
  document.addEventListener('focusin', function (event) {
    if (!isApp()) return;
    if (event.target.matches && event.target.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]), textarea, select')) {
      focusHidden = true;
      setHidden(true);
    }
  });
  document.addEventListener('focusout', function () {
    if (!focusHidden) return;
    // Moving from one field to the next fires focusout then focusin: wait a beat so the bar does not flicker.
    window.setTimeout(function () {
      var active = document.activeElement;
      if (active && active.matches && active.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]), textarea, select')) return;
      focusHidden = false;
      setHidden(false);
    }, 120);
  });

  /* ---- tapping a tab -------------------------------------------------------
     Tabs are plain links to real pages. A full page load of this storefront takes a moment, and the old page just
     sits there, so the tab answers instantly: it becomes current, shows a spinner and the top progress bar starts
     (adenzo-app.js). If the page comes back from the back/forward cache the original state is restored. */
  function tick(ms) {
    if (window.AdenzoApp && window.AdenzoApp.haptic) window.AdenzoApp.haptic(ms);
  }

  var tabs = Array.prototype.slice.call(bar.querySelectorAll('[data-tab]'));
  var initial = null;
  tabs.forEach(function (tab) { if (tab.getAttribute('aria-current') === 'page') initial = tab; });

  function resetTabs() {
    tabs.forEach(function (tab) {
      tab.classList.remove('is-loading');
      if (tab === initial) tab.setAttribute('aria-current', 'page'); else tab.removeAttribute('aria-current');
    });
  }

  bar.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-tab]') : null;
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
    tick(8);
    if (link === initial) return; // already here: the link just reloads the page
    tabs.forEach(function (tab) {
      tab.classList.remove('is-loading');
      tab.removeAttribute('aria-current');
    });
    link.setAttribute('aria-current', 'page');
    link.classList.add('is-loading');
  });

  window.addEventListener('pageshow', function (event) { if (event.persisted) resetTabs(); });

  /* ---- cart badge ------------------------------------------------------- */

  var lastCount = parseInt(badge && badge.textContent, 10) || 0;

  function setCount(count) {
    if (!badge) return;
    if (count > lastCount) tick(14); // something was added to the cart
    lastCount = count;
    badge.textContent = count > 99 ? '99+' : String(count);
    badge.hidden = !(count > 0);
  }

  function readHeaderCount() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return 0;
    var shown = bubble.querySelector('span[aria-hidden]');
    return shown ? parseInt(shown.textContent, 10) || 0 : 100; // no number shown means 100 or more
  }

  var headerCart = document.getElementById('cart-icon-bubble');
  if (headerCart && window.MutationObserver) {
    new MutationObserver(function () { setCount(readHeaderCount()); })
      .observe(headerCart, { childList: true, subtree: true });
  }

  // Back/forward cache can show a stale count.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !window.fetch) return;
    window.fetch((bar.getAttribute('data-cart-url') || '/cart').replace(/\/?$/, '') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { setCount(cart.item_count || 0); })
      .catch(function () { /* keep the current count */ });
  });

  /* ---- lifecycle -------------------------------------------------------- */

  if (window.ResizeObserver) new ResizeObserver(publish).observe(bar);
  window.addEventListener('resize', publish);
  document.addEventListener('adenzo:app-mode', publish);
  publish();
})();
